import { useDeviceType } from '@braskai/ui-kit';

import { PaywallDialog } from '@/shared/ui/PaywallCard';

import { DATA_TEST_IDS } from '../../lib/constants';
import { useOnscreenPaywallModalStore } from '../../model/useOnscreenPaywallModalStore';
import { OnscreenPaywall } from '../OnscreenPaywall';

// The on-screen text translation paywall opened from outside the project page: the upload modal and the home page.
export const OnscreenPaywallModal = () => {
  const { isMobile } = useDeviceType();
  const isOpen = useOnscreenPaywallModalStore((state) => state.isOpen);
  const pricingEntryPoint = useOnscreenPaywallModalStore((state) => state.pricingEntryPoint);
  const onLeaveForPricing = useOnscreenPaywallModalStore((state) => state.onLeaveForPricing);
  const close = useOnscreenPaywallModalStore((state) => state.close);

  if (!isOpen) return null;

  return (
    <PaywallDialog isMobile={isMobile} isOpen={isOpen} testId={DATA_TEST_IDS.paywall} onClose={close}>
      <OnscreenPaywall
        layout={isMobile ? 'sheet' : 'dialog'}
        pricingEntryPoint={pricingEntryPoint}
        onClose={close}
        onLeaveForPricing={onLeaveForPricing}
      />
    </PaywallDialog>
  );
};
